'use client'

import Link from 'next/link'
import { Dialog as DialogPrimitive } from 'radix-ui'
import { HugeiconsIcon } from '@hugeicons/react'
import type { IconSvgElement } from '@hugeicons/react'
import { Cancel01Icon, PlugSocketIcon } from '@hugeicons-pro/core-stroke-rounded'

export function AuthGateModal({
  open,
  onClose,
  title,
  body,
  accent = 'var(--color-brand)',
  icon = PlugSocketIcon,
  loginHref,
  signupHref,
  bodyId = 'auth-gate-body',
}: {
  open: boolean
  onClose: () => void
  title: string
  body: string
  accent?: string
  icon?: IconSvgElement
  loginHref: string
  signupHref: string
  bodyId?: string
}) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={o => !o && onClose()}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-[120] bg-black/45 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content
          aria-describedby={bodyId}
          className="fixed left-1/2 top-1/2 z-[120] w-[calc(100%-2rem)] max-w-[380px] -translate-x-1/2 -translate-y-1/2 rounded-card border-[0.5px] border-line bg-surface p-7 shadow-v3-card-hover outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"
        >
          <DialogPrimitive.Close
            aria-label="Close"
            className="absolute right-3.5 top-3.5 grid size-7 place-items-center rounded-ctrl text-text-muted transition-colors hover:text-text-strong focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40"
          >
            <HugeiconsIcon icon={Cancel01Icon} className="size-4" />
          </DialogPrimitive.Close>

          <div
            className="mb-4 grid size-[44px] place-items-center rounded-[12px] text-white shadow-v3-tile"
            style={{ background: accent }}
          >
            <HugeiconsIcon icon={icon} className="size-5" />
          </div>

          <DialogPrimitive.Title className="mb-1.5 text-[22px] font-bold leading-tight tracking-[-0.02em] text-text-strong">
            {title}
          </DialogPrimitive.Title>

          <DialogPrimitive.Description
            id={bodyId}
            className="mb-5 text-[13.5px] leading-relaxed text-text-muted-2"
          >
            {body}
          </DialogPrimitive.Description>

          <Link
            href={signupHref}
            className="mb-2 flex w-full items-center justify-center rounded-ctrl bg-brand px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40"
          >
            Create account
          </Link>
          <Link
            href={loginHref}
            className="flex w-full items-center justify-center rounded-ctrl border-[0.5px] border-line bg-surface px-4 py-3 text-sm font-semibold text-text-strong transition-colors hover:bg-canvas focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40"
          >
            Sign in
          </Link>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}
